// GlowShield — scripts propios (prefijo mt-)

function mtInitReveals() {
  const els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach((el) => el.classList.add('mt-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  els.forEach((el) => observer.observe(el));
}

function mtInitComparador() {
  document.querySelectorAll('[data-mt-comparador]').forEach((wrap) => {
    const handle = wrap.querySelector('[data-mt-comparador-handle]');
    const despues = wrap.querySelector('[data-mt-comparador-despues]');
    if (!handle || !despues) return;

    let dragging = false;

    function setPos(clientX) {
      const rect = wrap.getBoundingClientRect();
      let pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.min(100, Math.max(0, pct));
      despues.style.clipPath = `inset(0 ${100 - pct}% 0 0)`;
      handle.style.left = pct + '%';
    }

    handle.addEventListener('pointerdown', (e) => {
      dragging = true;
      handle.setPointerCapture(e.pointerId);
    });
    handle.addEventListener('pointerup', () => (dragging = false));
    handle.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      setPos(e.clientX);
    });
    wrap.addEventListener('click', (e) => {
      if (e.target === handle) return;
      setPos(e.clientX);
    });
  });
}

function mtInitCountUp() {
  const els = document.querySelectorAll('[data-mt-countup]');
  if (!els.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        observer.unobserve(el);
        const target = parseFloat(el.dataset.mtCountup);
        const suffix = el.dataset.mtSuffix || '';
        const duration = 1400;
        const start = performance.now();

        function tick(now) {
          const progress = Math.min(1, (now - start) / duration);
          const eased = 1 - Math.pow(1 - progress, 3);
          const value = target * eased;
          el.textContent = (Number.isInteger(target) ? Math.round(value) : value.toFixed(1)) + suffix;
          if (progress < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    },
    { threshold: 0.4 }
  );

  els.forEach((el) => observer.observe(el));
}

function mtInitGaleria() {
  document.querySelectorAll('[data-mt-galeria]').forEach((wrap) => {
    const mainImgId = wrap.dataset.mtGaleria;
    const mainImg = document.getElementById(mainImgId);
    if (!mainImg) return;

    wrap.querySelectorAll('[data-mt-miniatura]').forEach((btn) => {
      btn.addEventListener('click', () => {
        mainImg.src = btn.dataset.full;
        wrap.querySelectorAll('[data-mt-miniatura]').forEach((b) => b.classList.remove('mt-producto__miniatura--activa'));
        btn.classList.add('mt-producto__miniatura--activa');
      });
    });
  });
}

function mtInitVariantes() {
  document.querySelectorAll('[data-mt-form-producto]').forEach((form) => {
    const script = form.querySelector('[data-mt-variantes]');
    if (!script) return;

    let variantes;
    try {
      variantes = JSON.parse(script.textContent);
    } catch (e) {
      return;
    }

    const grupos = form.querySelectorAll('[data-mt-opcion]');
    const idInput = form.querySelector('[data-mt-variant-id]');
    const boton = form.querySelector('[data-mt-boton-comprar]');
    const botonTexto = form.querySelector('[data-mt-boton-texto]');
    const precioActual = form.closest('.mt-producto, .mt-cierre')?.querySelector('[data-mt-precio]');
    const precioAntes = form.closest('.mt-producto, .mt-cierre')?.querySelector('[data-mt-precio-antes]');

    function seleccionActual() {
      return Array.from(grupos).map((grupo) => {
        const activo = grupo.querySelector('.mt-producto__valor--activo');
        return activo ? activo.dataset.mtValor : null;
      });
    }

    function actualizar() {
      const seleccion = seleccionActual();
      const variante = variantes.find((v) =>
        v.options.every((opt, i) => opt === seleccion[i])
      );
      if (!variante) return;

      idInput.value = variante.id;

      if (precioActual) {
        precioActual.textContent = mtFormatMoney(variante.price);
      }
      if (precioAntes) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioAntes.textContent = mtFormatMoney(variante.compare_at_price);
          precioAntes.style.display = '';
        } else {
          precioAntes.style.display = 'none';
        }
      }
      if (boton) {
        boton.disabled = !variante.available;
        if (botonTexto) {
          botonTexto.textContent = variante.available
            ? botonTexto.dataset.mtTextoDisponible || botonTexto.textContent
            : botonTexto.dataset.mtTextoAgotado || botonTexto.textContent;
        }
      }
    }

    grupos.forEach((grupo) => {
      grupo.querySelectorAll('[data-mt-valor]').forEach((btn) => {
        btn.addEventListener('click', () => {
          grupo.querySelectorAll('[data-mt-valor]').forEach((b) => b.classList.remove('mt-producto__valor--activo'));
          btn.classList.add('mt-producto__valor--activo');
          actualizar();
        });
      });
    });
  });
}

function mtFormatMoney(cents) {
  return (cents / 100).toLocaleString(document.documentElement.lang || 'es-ES', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'EUR',
  });
}

function mtInitCarrusel() {
  document.querySelectorAll('[data-mt-carrusel]').forEach((wrap) => {
    const track = wrap.querySelector('[data-mt-carrusel-track]');
    const prev = wrap.querySelector('[data-mt-carrusel-prev]');
    const next = wrap.querySelector('[data-mt-carrusel-next]');
    const puntos = Array.from(wrap.querySelectorAll('[data-mt-carrusel-punto]'));
    if (!track) return;

    function slideWidth() {
      const slide = track.querySelector('.mt-carrusel__slide');
      return slide ? slide.getBoundingClientRect().width + 24 : track.clientWidth;
    }

    prev?.addEventListener('click', () => track.scrollBy({ left: -slideWidth(), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: slideWidth(), behavior: 'smooth' }));

    puntos.forEach((punto, i) => {
      punto.addEventListener('click', () => {
        track.scrollTo({ left: i * slideWidth(), behavior: 'smooth' });
      });
    });

    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const idx = Math.round(track.scrollLeft / slideWidth());
        puntos.forEach((p, i) => p.classList.toggle('mt-carrusel__punto--activo', i === idx));
        ticking = false;
      });
    });
  });
}

function mtInitVideo() {
  document.querySelectorAll('[data-mt-video]').forEach((caja) => {
    const boton = caja.querySelector('[data-mt-video-play]');
    const embed = caja.querySelector('[data-mt-video-embed]');
    const poster = caja.querySelector('.mt-video__poster');
    if (!boton || !embed) return;

    boton.addEventListener('click', () => {
      const tipo = caja.dataset.mtVideoType;
      const id = caja.dataset.mtVideoId;
      if (!tipo || !id) return;
      const src =
        tipo === 'youtube'
          ? `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`
          : `https://player.vimeo.com/video/${id}?autoplay=1`;
      embed.innerHTML = `<iframe src="${src}" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen title="Vídeo"></iframe>`;
      embed.hidden = false;
      if (poster) poster.style.display = 'none';
    });
  });
}

function mtInitFaq() {
  document.querySelectorAll('[data-mt-faq-boton]').forEach((boton) => {
    const panel = boton.parentElement.querySelector('[data-mt-faq-panel]');
    if (!panel) return;
    boton.addEventListener('click', () => {
      const abierto = boton.getAttribute('aria-expanded') === 'true';
      boton.setAttribute('aria-expanded', String(!abierto));
      panel.style.maxHeight = abierto ? '0px' : panel.scrollHeight + 'px';
    });
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll('[data-mt-faq-boton][aria-expanded="true"]').forEach((boton) => {
      const panel = boton.parentElement.querySelector('[data-mt-faq-panel]');
      if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
    });
  });
}

function mtInitLightbox() {
  document.querySelectorAll('[data-mt-lightbox]').forEach((lightbox) => {
    const galeria = lightbox.parentElement;
    const abrirBtn = galeria.querySelector('[data-mt-lightbox-abrir]');
    const miniaturas = Array.from(galeria.querySelectorAll('[data-mt-miniatura]'));
    const img = lightbox.querySelector('[data-mt-lightbox-img]');
    const cerrar = lightbox.querySelector('[data-mt-lightbox-cerrar]');
    const prev = lightbox.querySelector('[data-mt-lightbox-prev]');
    const next = lightbox.querySelector('[data-mt-lightbox-next]');
    if (!abrirBtn || !img) return;

    const urls = miniaturas.length
      ? miniaturas.map((m) => m.dataset.full)
      : [abrirBtn.querySelector('img')?.src].filter(Boolean);
    let indice = 0;

    function mostrar(i) {
      indice = (i + urls.length) % urls.length;
      img.src = urls[indice];
    }

    function abrir() {
      const activa = miniaturas.findIndex((m) => m.classList.contains('mt-producto__miniatura--activa'));
      mostrar(activa > -1 ? activa : 0);
      lightbox.hidden = false;
      requestAnimationFrame(() => lightbox.classList.add('mt-lightbox--visible'));
      document.body.style.overflow = 'hidden';
    }

    function cerrarModal() {
      lightbox.classList.remove('mt-lightbox--visible');
      document.body.style.overflow = '';
      setTimeout(() => (lightbox.hidden = true), 300);
    }

    abrirBtn.addEventListener('click', abrir);
    cerrar?.addEventListener('click', cerrarModal);
    prev?.addEventListener('click', () => mostrar(indice - 1));
    next?.addEventListener('click', () => mostrar(indice + 1));
    lightbox.addEventListener('click', (e) => {
      if (e.target === lightbox) cerrarModal();
    });
    document.addEventListener('keydown', (e) => {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') cerrarModal();
      if (e.key === 'ArrowLeft') mostrar(indice - 1);
      if (e.key === 'ArrowRight') mostrar(indice + 1);
    });
  });
}

function mtInitTilt() {
  const finoPuntero = window.matchMedia('(pointer: fine)').matches;
  const reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('.mt-tarjeta').forEach((tarjeta) => {
    tarjeta.addEventListener('pointermove', (e) => {
      const rect = tarjeta.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      tarjeta.style.setProperty('--mt-x', x + 'px');
      tarjeta.style.setProperty('--mt-y', y + 'px');

      if (!finoPuntero || reducido) return;
      const px = x / rect.width - 0.5;
      const py = y / rect.height - 0.5;
      tarjeta.dataset.mtTiltActivo = 'true';
      tarjeta.style.transform = `translateY(-4px) perspective(700px) rotateX(${(-py * 6).toFixed(2)}deg) rotateY(${(px * 6).toFixed(2)}deg)`;
    });

    tarjeta.addEventListener('pointerleave', () => {
      delete tarjeta.dataset.mtTiltActivo;
      tarjeta.style.transform = '';
    });
  });
}

function mtInitDemoInteractiva() {
  document.querySelectorAll('[data-mt-demo]').forEach((caja) => {
    const handle = caja.querySelector('[data-mt-demo-handle]');
    const barrido = caja.querySelector('[data-mt-demo-barrido]');
    const despues = caja.querySelector('[data-mt-demo-despues]');
    const germenes = caja.querySelector('.mt-demo__germenes');
    if (!handle || !despues) return;

    let dragging = false;
    const reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setPos(pct) {
      pct = Math.min(100, Math.max(0, pct));
      despues.style.clipPath = `inset(0 ${100 - pct}% 0 0)`;
      handle.style.left = pct + '%';
      if (barrido) barrido.style.left = pct + '%';
      if (germenes) germenes.style.opacity = String(1 - pct / 100);
    }

    function setPosFromClientX(clientX) {
      const rect = caja.getBoundingClientRect();
      setPos(((clientX - rect.left) / rect.width) * 100);
    }

    handle.addEventListener('pointerdown', (e) => {
      dragging = true;
      handle.setPointerCapture(e.pointerId);
    });
    handle.addEventListener('pointerup', () => (dragging = false));
    handle.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      setPosFromClientX(e.clientX);
    });
    caja.addEventListener('pointerdown', (e) => {
      if (e.target === handle) return;
      setPosFromClientX(e.clientX);
    });

    if (!reducido) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            observer.disconnect();
            let inicio = null;
            function animar(ts) {
              if (!inicio) inicio = ts;
              const progreso = Math.min(1, (ts - inicio) / 1600);
              const eased = 1 - Math.pow(1 - progreso, 2);
              setPos(eased * 78);
              if (progreso < 1) requestAnimationFrame(animar);
            }
            requestAnimationFrame(animar);
          });
        },
        { threshold: 0.5 }
      );
      observer.observe(caja);
    }
  });
}

function mtInitGaleriaVisual() {
  document.querySelectorAll('[data-mt-gv]').forEach((grid) => {
    const seccion = grid.closest('section').parentElement;
    const lightbox = seccion.querySelector('[data-mt-gv-lightbox]');
    if (!lightbox) return;
    const items = Array.from(grid.querySelectorAll('[data-mt-gv-item]'));
    const img = lightbox.querySelector('[data-mt-gv-img]');
    const cerrar = lightbox.querySelector('[data-mt-gv-cerrar]');
    const prev = lightbox.querySelector('[data-mt-gv-prev]');
    const next = lightbox.querySelector('[data-mt-gv-next]');
    let indice = 0;

    function mostrar(i) {
      indice = (i + items.length) % items.length;
      img.src = items[indice].dataset.full;
    }
    function abrir(i) {
      mostrar(i);
      lightbox.hidden = false;
      requestAnimationFrame(() => lightbox.classList.add('mt-lightbox--visible'));
      document.body.style.overflow = 'hidden';
    }
    function cerrarModal() {
      lightbox.classList.remove('mt-lightbox--visible');
      document.body.style.overflow = '';
      setTimeout(() => (lightbox.hidden = true), 300);
    }

    items.forEach((item, i) => item.addEventListener('click', () => abrir(i)));
    cerrar?.addEventListener('click', cerrarModal);
    prev?.addEventListener('click', () => mostrar(indice - 1));
    next?.addEventListener('click', () => mostrar(indice + 1));
    lightbox.addEventListener('click', (e) => {
      if (e.target === lightbox) cerrarModal();
    });
    document.addEventListener('keydown', (e) => {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') cerrarModal();
      if (e.key === 'ArrowLeft') mostrar(indice - 1);
      if (e.key === 'ArrowRight') mostrar(indice + 1);
    });
  });
}

function mtInitParallaxHero() {
  if (!window.matchMedia('(pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.querySelectorAll('[data-mt-parallax-zona]').forEach((zona) => {
    const img = zona.querySelector('[data-mt-parallax-img]');
    if (!img) return;

    zona.addEventListener('pointermove', (e) => {
      const rect = zona.getBoundingClientRect();
      const px = (e.clientX - rect.left) / rect.width - 0.5;
      const py = (e.clientY - rect.top) / rect.height - 0.5;
      img.style.transform = `translate(${(px * 16).toFixed(1)}px, ${(py * 16).toFixed(1)}px)`;
    });
    zona.addEventListener('pointerleave', () => {
      img.style.transform = '';
    });
  });
}

function mtInitCookies() {
  const banner = document.querySelector('[data-mt-cookies]');
  if (!banner) return;

  const CLAVE = 'mt-cookies-consent';
  let guardado;
  try {
    guardado = localStorage.getItem(CLAVE);
  } catch (e) {
    guardado = null;
  }
  if (guardado) return;

  banner.hidden = false;
  requestAnimationFrame(() => {
    setTimeout(() => banner.classList.add('mt-cookies--visible'), 400);
  });

  function guardarYOcultar(valor) {
    try {
      localStorage.setItem(CLAVE, valor);
    } catch (e) {
      /* localStorage no disponible: no persistimos, solo ocultamos */
    }
    banner.classList.remove('mt-cookies--visible');
    setTimeout(() => (banner.hidden = true), 500);
  }

  banner.querySelector('[data-mt-cookies-aceptar]')?.addEventListener('click', () => guardarYOcultar('accepted'));
  banner.querySelector('[data-mt-cookies-rechazar]')?.addEventListener('click', () => guardarYOcultar('essential-only'));
}

document.addEventListener('DOMContentLoaded', () => {
  mtInitReveals();
  mtInitComparador();
  mtInitCountUp();
  mtInitGaleria();
  mtInitVariantes();
  mtInitCarrusel();
  mtInitVideo();
  mtInitFaq();
  mtInitLightbox();
  mtInitTilt();
  mtInitDemoInteractiva();
  mtInitGaleriaVisual();
  mtInitParallaxHero();
  mtInitCookies();
});
